import React, { useEffect, useState } from "react";
// css comes in published_hw.css
import McqTypePublisedQuestion from "./PublishQuestionType/McqType/McqTypePublisedQuestion";
import axios from "../../../../../axios";
import ImgTypePublishedQuestion from "./PublishQuestionType/ImgType/ImgTypePublishedQuestion";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import DeleteConfirmation from "./PublishQuestionType/DeleteConfirmation/DeleteConfirmation";
import { Popup } from "semantic-ui-react";
import HwCompletedStudentList from "./HwCompletedStudentList";
import PrintAssessment from "../../../../../Assesment/pages/On_going/SChedule/Schedule_Q_List/PrintAssessment";
import PrintHomeWorkQs from "./PrintHomeWorkQs";
import { toast } from "react-toastify";
export default function PublishedQListHW() {
  const navigate = useNavigate();
  const [publicData, setPublicData] = useState({
    preCompleteSList: [],
  });
  const [questions, setQuestions] = useState([]);
  const [homework, setHomework] = useState([]);
  const [homeworkName, setHomeworkName] = useState("");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [description, setDescription] = useState("");
  const [deadline, setDeadline] = useState("");
  const [subject, setSubject] = useState("");
  const [unableToDeletePara, setUnableToDeletePara] = useState("");
  //Add loader
  const [isGettingData, setIsGettingData] = useState(false);
  const { state } = useLocation();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  let isFromDcm = localStorage.getItem("from");
  let supplement_id = JSON.parse(localStorage.getItem("supplementId"));
  useEffect(() => {
    const QuestionHelper = async () => {
      try {
        const response = await axios.get(
          `/api/v1/homework/get/${state?.homework_id}`
        );
        setHomework(response?.data?.data);
        setQuestions(response?.data?.data?.questions);
        setHomeworkName(response?.data?.data?.name);
        setDescription(response?.data?.data?.description);
        setDeadline(response?.data?.data?.deadline);
        setSubject(response?.data?.data?.subject_id.name);
      } catch (error) {
        console.log("error", error);
        toast.error("Something went wrong for selected card!!");
      }
    };
    QuestionHelper();
  }, []);
  useEffect(() => {
    try {
      setIsGettingData(true);
      const helper = async () => {
        const preCompleteSList = await axios.get(
          `/api/v1/homework/studentHomework/getByHomeworkId/${state?.homework_id}?status=pending&isOnlyList=true` //update this according to need for count of students - status=review&isOnlyList=true
        );
        preCompleteSList &&
          setPublicData({
            preCompleteSList: preCompleteSList.data.data,
          });
        setIsGettingData(false);
      };
      helper();
    } catch (error) {
      setIsGettingData(false);
      console.log(error);
    }
  }, []);
  function formatDate(inputDate) {
    if (!inputDate) return null;
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}/${month}/${year}`;
  }
  const Deadline = formatDate(deadline);
  const handleDeleteClick = () => {
    if (questions.length === 0) return;
    setShowDeleteConfirmation(true);
  };
  const handleDeleteConfirmationClose = () => {
    setShowDeleteConfirmation(false);
  };
  const handleDeleteCancel = () => {
    setShowDeleteConfirmation(false);
  };
  const handleDeleteConfirm = async () => {
    try {
      const response = await axios.delete(
        `/api/v1/homework/delete/${state?.homework_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
          data: {
            teacher_id: Teacher_Json,
          },
        }
      );
      if (response.status === 200) {
        setShowDeleteConfirmation(false);
        navigate("/PublishedHomework");
      }
    } catch (error) {
      if (error.response.data && error.response.data.status === false) {
        setUnableToDeletePara(
          "Only the teacher who created this homework can delete!"
        );
      }
      console.log(error);
    }
  };
  const myList = publicData.preCompleteSList;
  const totalLength = myList.length;
  // const totalLength = myList
  //   ?.map((array) => array.length)
  //   .reduce((sum, length) => sum + length, 0);

  return (
    <>
      {isGettingData ? (
        <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <>
          <div>
            <div className="d-flex align-items-center navigationPublished ">
              <NavLink
                state={{ supplement_id: supplement_id }}
                to={
                  localStorage.getItem("Header") === "Content Management"
                    ? "/contentMangment"
                    : isFromDcm === "DCM"
                    ? "/DcmTimeTable"
                    : isFromDcm === "Summary"
                    ? `/ViewSummary`
                    : "/PublishedHomework"
                }
                className="link"
              >
                <img src="/images/Back Arrow.svg" alt=""></img>
              </NavLink>
              {isFromDcm && (
                <span className="open_publish_path">
                  &nbsp;{" "}
                  <NavLink
                    state={{ supplement_id: supplement_id }}
                    className="link"
                    to={isFromDcm === "DCM" ? "/DcmTimeTable" : `/ViewSummary`}
                  >
                    <span className="open_publish_path">{isFromDcm} /</span>
                  </NavLink>
                </span>
              )}
              <Link
                to={
                  localStorage.getItem("Header") === "Content Management"
                    ? "/contentMangment"
                    : "/PublishedHomework"
                }
                className="link"
              >
                <span className="published_hw_file_path1">
                  &nbsp; Homework /&nbsp;
                </span>
              </Link>{" "}
              <span className="published_hw_file_path2"> {homeworkName}</span>
            </div>
            <div className="mt-2 ms-1 published_tittle_heading">
              {description}
            </div>
            <div className="me-5 d-flex align-items-center justify-content-between">
              <div className="mt-1 ms-1  d-flex align-items-center ">
                <span className=" open_ststus_hw ">Published</span>{" "}
                <span className="greyText">{subject}</span>{" "}
                <span className="greyText">| Deadline </span>
                <span className="DeadlineText">{Deadline}</span>
                <div className="mx-2 hw_status_box d-flex align-items-center">
                  {/* <img
                      src="/images/memberListIcon.png"
                      alt=""
                      className="hw_firstp"
                      style={{ width: "25px", borderRadius: "50%", border: "1px solid gray" }}
                    /> */}
                  <img
                    src="/images/memberListIcon.png"
                    alt=""
                    className="hw_secondp"
                    style={{
                      width: "37px",
                      height: "36px",
                      borderRadius: "50%",
                      border: "1px solid gray",
                    }}
                  />

                  <Popup
                    on="click"
                    // className="completed_list"
                    trigger={
                      <div className="nth_personsp d-flex align-items-center justify-content-center">
                        {totalLength}
                      </div>
                    }
                    content={
                      <HwCompletedStudentList
                        homework_id={state?.homework_id}
                        totalLength={totalLength}
                      />
                    }
                    position=" right "
                  />
                </div>
              </div>
              <div className="d-flex align-items-center gap-3">
                {/* <PrintHomeWorkQs homework={homework} Deadline={Deadline} /> */}
                <button
                  className="hw_delet_button px-4"
                  onClick={() => PrintHomeWorkQs(homework, false, "Homework")}
                >
                  Export to PDF
                </button>
                {console.log(homework, "adnwkan")}
                <button
                  className="hw_delet_button px-4"
                  onClick={handleDeleteClick}
                >
                  Delete
                </button>
              </div>
            </div>
            <div
              className=" orange-scrollBar"
              style={{
                maxHeight: "450px",
                overflow: "auto",
                paddingBottom: "10px",
              }}
            >
              {questions &&
                questions.length > 0 &&
                questions.map((question, index) => {
                  // I added (question.type.type === "descriptive" || question.type.is_manually_graded) I campare question type with type same as android side
                  if (
                    question?.type?.type === "descriptive" ||
                    question?.type?.is_manually_graded
                  ) {
                    return (
                      <ImgTypePublishedQuestion
                        key={index}
                        title={question.title}
                        options={question.options}
                        correctAns={question.correct_answers}
                        queNo={index}
                        chap={question.chapter.chapterName}
                        skills={question.skill.name}
                        knowDom={question.domain.name}
                        difficulty_level={question.difficulty_level.name}
                        attachments={question.attachments}
                        Correct_Score={question.correct_score}
                        is_mandatory={question.is_mandatory}
                        addHW={question.add_to}
                      />
                    );
                    // I added (question.type.type === "multiple choice" || !question.type.is_manually_graded) I campare question type with type same as android side
                  } else if (
                    question?.type?.type === "multiple choice" ||
                    !question?.type?.is_manually_graded
                  ) {
                    return (
                      <McqTypePublisedQuestion
                        key={index}
                        title={question.title}
                        options={question.options}
                        correctAns={question.correct_answers}
                        queNo={index}
                        chap={question.chapter.chapterName}
                        skills={question.skill.name}
                        knowDom={question.domain.name}
                        attachments={question.attachments}
                        Correct_Score={question.correct_score}
                        difficulty_level={question.difficulty_level.name}
                        is_mandatory={question.is_mandatory}
                        addHW={question.add_to}
                      />
                    );
                  }
                })}
            </div>
          </div>
          {showDeleteConfirmation && (
            <DeleteConfirmation
              onConfirm={handleDeleteConfirm}
              onCancel={handleDeleteCancel}
              errorText={unableToDeletePara}
            />
          )}
        </>
      )}
    </>
  );
}
